<template>
  <section class="columns">
    <div class="column is-one-fifth"></div>
    <div class="wrapper column is-three-fifths card">
      <div class="columns">
        <div class="column is-three-fifths is-hidden-desktop">
          <img src="~@/assets/images/bpbd.png" class="login-image" alt="Indonesia"/>
          <br/>
        </div>
        <div class="column is-two-fifths">
          <h2>Welcome to DIMS Center</h2>
          <h3>Please Login</h3>
          <b-field label="Username">
            <b-input placeholder="username" v-model="form.username"/>
          </b-field>
          <b-field label="Password">
            <b-input type="password" v-model="form.password" @keyup.enter.native="doLogin"/>
          </b-field>
          <b-button @click="doLogin">Submit</b-button>
        </div>
        <div class="column is-three-fifths is-hidden-mobile">
          <img src="~@/assets/images/bpbd.png"
             class="login-image login-image-desktop" alt="Indonesia"/>
        </div>
      </div>
    </div>
    <div class="column is-one-fifth"></div>
  </section>
</template>

<style lang="scss" scoped>
.wrapper {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 5px;
  padding: 40px;

  @media only screen and (min-width: 768px) {
    margin-top: 20vh;
  }
}
.login {
  &-image {
    width: 250px;
    border-radius: 50%;

    &-desktop {
      margin-top: 30px;
      float: right;
    }
  }
}
</style>
<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'LoginPage',
  data () {
    return {
      form: {
        username: '',
        password: ''
      }
    }
  },
  created () {
    if (this.isLoggedIn) {
      this.redirect()
      return
    }
    this.hideSideBar()
    this.hideNavBar()
  },
  destroyed () {
    this.showSideBar()
    this.showNavBar()
  },
  computed: {
    ...mapGetters('Auth', ['isLoggedIn']),
    redirectUrl () {
      return this.$route.query.redirect || '/dashboard'
    }
  },
  methods: {
    ...mapActions(['hideSideBar', 'hideNavBar',
      'showSideBar', 'showNavBar']),
    ...mapActions('Auth', ['login']),
    doLogin () {
      this.login({
        data: {
          ...this.form
        }
      })
      .then(this.redirect)
      .catch(() => {
        alert("Username / password tidak cocok.")
      })
    },
    redirect () {
      this.$router.replace(this.redirectUrl)
    }
  }
}
</script>
